import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getRankNames } from '../../services'
import { RankQueryKeys } from '@/modules/manage-rank/keys'
import { GetRankNamesResponse } from '@/modules/manage-rank/type'

export default function useQueryGetRankName(
	props?: UseBaseQueryOptions<GetRankNamesResponse>,
) {
	return useQuery({
		queryKey: [RankQueryKeys.GetRankNames],
		queryFn: () => getRankNames(),
		...props,
	})
}
